import { render, staticRenderFns } from "./footComponents.vue?vue&type=template&id=4e1ce3ac"
import script from "./footComponents.vue?vue&type=script&lang=js"
export * from "./footComponents.vue?vue&type=script&lang=js"
import style0 from "./footComponents.vue?vue&type=style&index=0&id=4e1ce3ac&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports